export const LOCALSTORAGE_MAP_INFOBOX_EXPAND = 'HOMEPAGE.MAP.INFOBOX.EXPAND';
